import { GetServerSideProps } from "next";
import { getLocale } from "lib/localization";
import { getStaticPropsGetter } from "components/category-page-next/category-server-methods";
import { getGeoCountry } from "lib/get-geo-country";
import { trackClick } from "lib/api/track-click";

export const getStaticPropsCall = getStaticPropsGetter("FRIENDSHIP");
export { default } from "components/the-buzz-theme/page/category";
export const getServerSideProps: GetServerSideProps = async function ({ req }) {
  const lang = getLocale(req);

  trackClick(req.headers, req.url, lang);

  const { props } = await getStaticPropsCall({ params: { lang } });

  return {
    props: {
      geoIpCountry: getGeoCountry(req),
      ...props,
    },
  };
};
